import React, { Component } from "react";
import { Card, Button, Image } from "semantic-ui-react";
import PropTypes from "prop-types";
import ApexCharts from "apexcharts";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import { connect } from "react-redux";
import { solveProblemAction } from "../../actions/changeActiveItemActions";

let dpWaveFormOptions = {
  series: [{ data: [] }],
  chart: {
    type: "line",
  },
  colors: [Constants.PURPLE_HEX],
  markers: {
    size: 0
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: Strings.WAVE_FORM,
    align: "center",
    style: {
      fontSize: "14px",
      fontFamily: "Helvetica, Arial, sans-serif"
    }
  },
  stroke: {
    curve: "straight",
    width: 2
  },
  xaxis: {
    type: "numeric",
    title: {
      text: Strings.TIME_NS
    },
    crosshairs: {
      show: "true"
    },
    labels: {
      show: true,
      style: {
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        cssClass: "apexcharts-xaxis-label",
      }
    }
  },
  yaxis: {
    min: -8,
    max: 8,
    tickAmount: 16,
    labels: {
      show: true,
      formatter: function (val) {
        return val.toFixed(2) + " V";
      },
      style: {
        colors: [],
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: 400,
        cssClass: "apexcharts-yaxis-label",
      }
    },
    title: {
      text: Strings.VOLTAGE_V
    },
  },
  annotations: {
    position: "front",
    xaxis: []
  }
};

export class ProblemCard extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      waveImg: "",
      isFiveChannelsScope: sessionStorage.getItem("fiveChannels") === "true"
    };
  }

  getProblemHeader = () => {
    if (this.props.problem.type === Constants.TERMINATION_OFF_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.TERMINATION_OFF_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.NO_POWER_SUPPLY_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.HIGH_RESISTANCE_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.HIGH_RESISTANCE_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.A_NOT_OK_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.A_NOT_OK_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.B_NOT_OK_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.B_NOT_OK_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.LONG_CABLE_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.LONG_CABLE_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.NOISE_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.NOISE_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.REFLECTION_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.REFLECTION_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.FIBER_SIGNAL_LOSS_LIST_HEADER}
        </Card.Header>
      );
    }
    else {
      return "";
    }
  }

  formatTime = () => {
    let ntp = this.props.problem.ntp;

    if (typeof (this.props.problem.ntp) === "string") {
      ntp = this.props.problem.ntp === "True" ? true : false;
    }

    if (ntp !== null && ntp === true && this.props.problem.time !== undefined && this.props.problem.time !== null) {
      let parsedMillis = Date.parse(this.props.problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (this.props.problem.time !== undefined && this.props.problem.time !== null) {
      const eventTimeInMillis = this.props.problem.time * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getProblemMeta = () => {
    let problemDate = this.formatTime();

    return (
      <Card.Meta>
        <strong>
          {Strings.DETECTED_ON}
          {problemDate}
        </strong>
      </Card.Meta>
    );
  }

  handleSolvedButtonClick = async () => {
    this.props.onProblemSolve(true, this.props.problem);
  }

  getFormatedDPOptions = (wave, dpOptions) => {
    let options = {};

    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_US
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_MS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }

    return options;
  }

  formatDPWaveTimes = (wave) => {
    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds 
      // (it already is by default, so do nothing here)
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / (10 ** 3);
      }
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      for (let i = 0; i < wave.length; i++) {
        wave[i][0] = wave[i][0] / (10 ** 6);
      }
    }

    return wave;
  }

  getBAOscilloscopeImgURI = async (wave) => {
    if (wave !== null && wave !== undefined) {

      document.getElementById("chart").style.display = "block";

      // Render the chart
      let chart = new ApexCharts(document.querySelector("#chart"), dpWaveFormOptions);
      chart.render();

      // Render the wave B - A to get its imgURI
      let options = this.getFormatedDPOptions(wave, dpWaveFormOptions);

      options = {
        ...options,
        title: {
          text: Strings.B_A,
          align: "center",
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif"
          }
        },
        colors: [Constants.PURPLE_HEX],
        series: [
          { name: Strings.WAVE_B_A, data: this.formatDPWaveTimes(wave) }
        ]
      };

      chart.updateOptions(options, false, false, false);

      let imgURIObj = await chart.dataURI();

      document.getElementById("chart").style.display = "none";

      chart.destroy();

      return imgURIObj.imgURI;
    }
    else {
      return Constants.LOADING_IMG;
    }
  }

  getABOscilloscopeImgURI = async (waveA, waveB) => {
    if (waveA !== undefined && waveA !== null && waveB !== undefined && waveB !== null) {

      document.getElementById("chart").style.display = "block";

      // Render the chart
      let chart = new ApexCharts(document.querySelector("#chart"), dpWaveFormOptions);
      chart.render();

      // Render the wave B - A to get its imgURI
      let options = this.getFormatedDPOptions(waveA, dpWaveFormOptions);

      options = {
        ...options,
        title: {
          text: Strings.A_AND_B,
          align: "center",
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif"
          }
        },
        colors: [Constants.GREEN_HEX, Constants.RED_HEX],
        series: [
          { name: Strings.WAVE_A, data: this.formatDPWaveTimes(waveA) },
          { name: Strings.WAVE_B, data: this.formatDPWaveTimes(waveB) }
        ]
      };

      chart.updateOptions(options, false, false, false);

      let imgURIObj = await chart.dataURI();

      document.getElementById("chart").style.display = "none";

      chart.destroy();

      return imgURIObj.imgURI;
    }
    else {
      return Constants.LOADING_IMG;
    }
  }

  setImage = async () => {

    let wave = "data:,";

    if (this.props.problem.type === Constants.TERMINATION_OFF_PROBLEM_TYPE
      || this.props.problem.type === Constants.NO_POWER_SUPPLY_PROBLEM_TYPE
      || this.props.problem.type === Constants.HIGH_RESISTANCE_PROBLEM_TYPE
      || this.props.problem.type === Constants.LONG_CABLE_PROBLEM_TYPE
      || this.props.problem.type === Constants.REFLECTION_PROBLEM_TYPE) {

      while (wave === "data:,") {
        wave = await this.getBAOscilloscopeImgURI(this.props.problem.wave);
      }

    }
    else if (this.props.problem.type === Constants.A_NOT_OK_PROBLEM_TYPE
      || this.props.problem.type === Constants.B_NOT_OK_PROBLEM_TYPE
      || this.props.problem.type === Constants.NOISE_PROBLEM_TYPE) {

      while (wave === "data:,") {
        wave = await this.getABOscilloscopeImgURI(this.props.problem.waveA, this.props.problem.waveB);
      }
    }

    this.setState({ waveImg: wave }, () => {
      let waveImgElement = document.getElementById(this.props.problem._id + " / imgWave");
      waveImgElement.style.visibility = "visible";
      waveImgElement.style.display = "block";
    });
  }

  getEventChannel = () => {
    if (this.state.isFiveChannelsScope) {
      return <p><b>{Strings.CHANNEL}: </b> {this.props.problem.channel}</p>;
    }
    else {
      return "";
    }
  }

  getCardDescription = () => {
    if (this.props.problem.type !== Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      if (this.props.problem.type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE || this.props.problem.type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {

        let voltage = this.props.problem.voltage !== null ? parseFloat(this.props.problem.voltage).toFixed(2) : Strings.UNKNOWN;

        return (
          <Card.Description>
            <p><b>{Strings.CHANNEL}: </b> {this.props.problem.channel}</p>
            <p><b>{Strings.VOLTAGE_}: </b> {voltage} V</p>
          </Card.Description>
        );
      }
      else {
        return (
          <Card.Description>
            {this.getEventChannel()}
            <p>{Strings.EVIDENCE_DESCRIPTION}</p>
            <Image
              id={this.props.problem._id + " / imgWave"}
              centered
              src={this.state.waveImg}
              style={hiddenImageStyle}
              onError={() => console.log("Error loading image")}
            />
          </Card.Description>
        );
      }
    }
  }

  componentDidMount = () => {
    if (this.props.problem.type !== Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE
      && this.props.problem.type !== Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE
      && this.props.problem.type !== Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      this.setImage();
    }
  }

  render() {
    return (
      <Card id={this.props.problem._id} fluid raised>
        <Card.Content>

          {this.getProblemHeader()}
          {this.getProblemMeta()}
          {this.getCardDescription()}

        </Card.Content>
        <Card.Content extra>
          <Button
            basic
            color='green'
            fluid
            onClick={this.handleSolvedButtonClick}>
            {Strings.CHECKED}
          </Button>
        </Card.Content>
        <div id="chart" style={chartsStyle}></div>
      </Card >
    );
  }
}

const mapStateToProps = state => ({
  active: state
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

ProblemCard.propTypes = {
  nowMillis: PropTypes.number.isRequired,
  startTime: PropTypes.number.isRequired,
  problem: PropTypes.object.isRequired,
  onProblemSolve: PropTypes.func
};

const chartsStyle = {
  position: "absolute",
  left: "0px",
  top: "0px",
  zIndex: "-1",
  width: "525px",
  height: "250px",
  display: "none",
  visibility: "hidden"
};

const hiddenImageStyle = {
  visibility: "hidden",
  display: "none",
};

export default connect(mapStateToProps, mapActionsToProps)(ProblemCard);